import { setDefaultLang, setTranslationObject } from "simple-body-validator";
import translations from "./lang";

// rules setup
import "./rules";

// translation setup

setTranslationObject(translations);
setDefaultLang("es");
